import {Injectable} from '@angular/core';
import {ProductOffering} from '@uofu-uss-aux/software-catalog-ng-core';

@Injectable({
  providedIn: 'root'
})
export class PriceService {

  constructor() {
  }

  getPriceRange(offerings: ReadonlyArray<ProductOffering>): ReadonlyArray<number> {
    if (offerings && offerings.length) {
      const sortedPrices = offerings.map(o => o.price).sort();
      return [sortedPrices[0], sortedPrices[sortedPrices.length - 1]];
    } else {
      return [0, 0];
    }
  }
}
